import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DeclineDialogData {
  keyPrefix: string;
}

export interface DeclineDialogResult {
  confirmed: boolean;
  reason: string;
}

@Component({
  selector: 'app-decline-dialog',
  standalone: false,
  templateUrl: './decline-dialog.component.html',
  styleUrls: ['./decline-dialog.component.scss']
})
export class DeclineDialogComponent {
  declineReason = '';

  constructor(
    public dialogRef: MatDialogRef<DeclineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeclineDialogData
  ) {}

  onClose(): void {
    this.dialogRef.close(null);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onDecline(): void {
    this.dialogRef.close({ confirmed: true, reason: this.declineReason } as DeclineDialogResult);
  }
}
